<template>
  <div
    :class="['create-btn', { dark: !isChinese() }]"
    @click="handleCreateWork"
  >
    <iconpark-icon name="create" size="20" class="mr-[4px]"></iconpark-icon>
    {{ isChinese() ? $t('ai-chuang-zuo') : $t('xin-jian-zuo-pin') }}
  </div>
</template>

<script lang="ts" setup>
import { useCreateWork } from '~/features/createWork'

const handleCreateWork = () => {
  const userInfo = useUserInfo()
  if (!userInfo.value) {
    loginTask.add({
      type: IAfterLoginActionType.CREATE_WORK,
      payload: {},
    })
    navigateTo('/login?redirect=' + encodeURIComponent(location.href))
  } else {
    useCreateWork()
  }
}
</script>

<style lang="scss" scoped>
.create-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 36px;
  padding: 8px 20px 8px 14px;
  border-radius: 8px;
  font-weight: 600;
  color: var(--purple-6);
  border: 1px solid var(--purple-4);

  &:hover {
    background: var(--purple-6);
    border: 1px solid var(--purple-6);
    color: #fff;
  }

  &.dark {
    background: var(--purple-6);
    border: 1px solid var(--purple-6);
    color: #fff;
    &:hover {
      color: #fff;
      background-color: #524cc8;
      border: 1px solid transparent;
    }
  }
}
</style>
